export class MultipleChoiceQuizData {
    constructor() {
        this.className = "";
        this.parameterData = {};
    }
    deserialize(input) {
        this.className = input.className;
        this.parameterData = input.parameterData;
        return this;
    }
}
